import { CenterChildren } from '@editor/components/utilities/layouts';
import { darkBackgroundBlur } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const TooltipWrapper = styled(CenterChildren)<{
  isPositioned: boolean;
  maxWidth?: string;
}>`
  position: absolute;
  background-color: ${themeStyle.varInkMain};
  color: ${themeStyle.varInkBase};
  font-weight: ${themeStyle.fontMedium};
  padding: 0 4px;
  height: 24px;
  gap: 2px;
  font-size: ${themeStyle.fontSize11};
  border-radius: ${themeStyle.radiusSmall};
  box-shadow: ${themeStyle.varShadowHeavy};
  z-index: 999;
  opacity: ${({ isPositioned }) => (isPositioned ? '1' : '0')};
  transition: opacity 225ms;
  text-align: center;
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'unset')};

  ${darkBackgroundBlur};
  html[data-theme='dark'] &&,
  .dark && {
    background-color: ${themeStyle.varBackgroundAlt};
    color: ${themeStyle.varInkMain};
  }

  @media (hover: none) {
    display: none;
  }
`;

export const TextWrapper = styled.span`
  padding: 0 4px;
`;

export const PlusWrapper = styled.span`
  padding: 0 2px;
  font-size: ${themeStyle.fontSize11};
  color: ${themeStyle.varInkLightMedium};
`;
